"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _BuySellBalancesComponent = _interopRequireDefault(require("./BuySellBalancesComponent"));
var _productPositionSelectors = require("../../../../redux/selectors/productPositionSelectors");
var _instrumentPositionSelectors = require("../../../../redux/selectors/instrumentPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var selectedInstrument = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state);
  var product1 = (0, _productPositionSelectors.getProductByIdSelector)(state, selectedInstrument.Product1);
  var product2 = (0, _productPositionSelectors.getProductByIdSelector)(state, selectedInstrument.Product2);
  return {
    product1: product1,
    product2: product2
  };
};
var mapDispatchToProps = {};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BuySellBalancesComponent["default"]);